import React, { useContext } from 'react';
import { LanguageContext } from '../../App';
import { MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { staggerContainer, listItem, cardHover } from '../../utils/animations';
interface DriverListProps {
  onDriverSelect: (driver: any) => void;
}
export const DriverList: React.FC<DriverListProps> = ({
  onDriverSelect
}) => {
  const {
    language
  } = useContext(LanguageContext);
  const driverAvatars = ['https://i.ibb.co/xG0Jcnm/driver1.jpg', 'https://i.ibb.co/k2V6YPL/driver2.jpg', 'https://i.ibb.co/0hFTSyy/driver3.jpg', 'https://i.ibb.co/wdQSrBL/driver4.jpg', 'https://i.ibb.co/bRZmtTG/driver5.jpg'];
  const drivers = [{
    id: 1,
    name: 'Rahul Sharma',
    status: 'available',
    location: 'Salmiya, Block 10',
    orders: 5,
    rating: 4.9,
    avatar: driverAvatars[0]
  }, {
    id: 2,
    name: 'Ahmed Khan',
    status: 'on_delivery',
    location: 'Kuwait City, Block 3',
    orders: 3,
    rating: 4.7,
    avatar: driverAvatars[1]
  }, {
    id: 3,
    name: 'Farhan Qureshi',
    status: 'available',
    location: 'Hawally, Block 5',
    orders: 2,
    rating: 4.8,
    avatar: driverAvatars[2]
  }, {
    id: 4,
    name: 'Arjun Patel',
    status: 'on_delivery',
    location: 'Jabriya, Block 1',
    orders: 4,
    rating: 4.6,
    avatar: driverAvatars[3]
  }, {
    id: 5,
    name: 'Imran Malik',
    status: 'available',
    location: 'Kuwait City, Block 6',
    orders: 1,
    rating: 4.5,
    avatar: driverAvatars[4]
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'available':
        return 'bg-green-500';
      case 'on_delivery':
        return 'bg-yellow-500';
      case 'offline':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };
  const getStatusText = (status: string) => {
    if (language === 'en') {
      switch (status) {
        case 'available':
          return 'Available';
        case 'on_delivery':
          return 'On Delivery';
        case 'offline':
          return 'Offline';
        default:
          return 'Unknown';
      }
    } else {
      switch (status) {
        case 'available':
          return 'متاح';
        case 'on_delivery':
          return 'في مهمة توصيل';
        case 'offline':
          return 'غير متصل';
        default:
          return 'غير معروف';
      }
    }
  };
  return <motion.div className="space-y-3 overflow-y-auto max-h-[300px] pr-1" variants={staggerContainer} initial="hidden" animate="visible" data-id="element-47">
      {drivers.map(driver => <motion.div key={driver.id} className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors" onClick={() => onDriverSelect(driver)} variants={listItem} whileHover={cardHover} data-id="element-48">
          <div className="flex items-center" data-id="element-49">
            <div className="flex-shrink-0" data-id="element-50">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden" data-id="element-51">
                <img src={driver.avatar} alt={driver.name} className="w-full h-full object-cover" data-id="element-52" />
              </div>
            </div>
            <div className="ml-3 flex-1" data-id="element-53">
              <div className="flex items-center justify-between" data-id="element-54">
                <div className="text-sm font-medium text-gray-900" data-id="element-55">
                  {driver.name}
                </div>
                <div className="flex items-center" data-id="element-56">
                  <motion.div className={`w-2 h-2 rounded-full ${getStatusColor(driver.status)}`} initial={{
                scale: 0.8
              }} animate={{
                scale: [0.8, 1.2, 0.8]
              }} transition={{
                repeat: Infinity,
                duration: 2,
                ease: 'easeInOut'
              }} data-id="element-57" />
                </div>
              </div>
              <div className="text-xs text-gray-500" data-id="element-58">
                {getStatusText(driver.status)}
              </div>
              <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-59">
                <MapPinIcon size={12} className="mr-1 flex-shrink-0" data-id="element-60" />
                <span className="truncate" data-id="element-61">{driver.location}</span>
              </div>
            </div>
          </div>
        </motion.div>)}
    </motion.div>;
};